module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('transition', {
    attrs: {
      "name": "mu-popover"
    },
    on: {
      "after-enter": function($event) {
        return _vm.show()
      },
      "after-leave": function($event) {
        return _vm.hide()
      }
    }
  }, [(_vm.open) ? _c('div', {
    ref: "popup",
    staticClass: "mu-popover",
    class: _vm.popoverClass,
    style: ({
      'z-index': _vm.zIndex
    })
  }, [_vm._t("default")], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fc6143f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/popover/popover.vue
// module id = 3806
// module chunks = 1